<app-modal (dismissed)="onCancelClick()" width="min(460px, calc(100vw - 24px))">
    <div class="general-dialog">
        <header class="dialog-header">
            <span class="eyebrow">{{ 'Confirm Action' | translate }}</span>
            <div [innerHTML]="bodyText | translate" class="dialog-title"></div>
        </header>

        <div class="dialog-body">
            <div *ngIf="showReason" class="dialog-field">
                <label for="suspendReason">{{ 'Reason' | translate }}</label>
                <input (ngModelChange)="setReason($event)" [(ngModel)]="suspendReason" class="form-control"
                       id="suspendReason"
                       [placeholder]="'Reason' | translate" maxlength="30" name="suspendReason"
                       type="text"/>

                <div class="radio-wrapper">
                    <label class="radio-option">
                        <input (change)="radioValueSuspensionHours(2)" class="radio-input" name="inlineRadioOptions"
                               type="radio" value="2"/>
                        <span>2h</span>
                    </label>
                    <label class="radio-option">
                        <input (change)="radioValueSuspensionHours(4)" class="radio-input" name="inlineRadioOptions"
                               type="radio" value="4"/>
                        <span>4h</span>
                    </label>
                    <label class="radio-option">
                        <input (change)="radioValueSuspensionHours(999999)" class="radio-input"
                               name="inlineRadioOptions"
                               type="radio" value="9999999"/>
                        <span>{{ 'Permanent' | translate }}</span>
                    </label>
                </div>
            </div>

            <div *ngIf="showPriceInput" class="dialog-field">
                <label for="priceInput">{{ 'Price per km' | translate }}</label>
                <input (ngModelChange)="setPrice($event)" [(ngModel)]="priceInput" class="form-control" id="priceInput"
                       maxlength="30" name="priceInput" placeholder="Ex: 2.59"
                       type="number"/>

                <div class="radio-wrapper">
                    <label class="radio-option">
                        <input (change)='radioPackageType("standard")' class="radio-input" name="inlineRadioOptions"
                               type="radio" value="standard"/>
                        <span>{{ 'Standard' | translate }}</span>
                    </label>
                    <label class="radio-option">
                        <input (change)='radioPackageType("premium")' class="radio-input" name="inlineRadioOptions"
                               type="radio" value="premium"/>
                        <span>{{ 'Premium' | translate }}</span>
                    </label>
                </div>
            </div>

            <div class="dialog-actions">
                <button (click)="onCancelClick()" class="btn btn-success" type="button">
                    {{ cancelButtonText | translate }}
                </button>
                <button (click)="onConfirmClick()" class="btn btn-danger" type="button">
                    {{ confirmButtonText | translate }}
                </button>
            </div>
        </div>
    </div>
</app-modal>
